import Cookies from 'js-cookie';
import { COOKIES_LOOKUP } from 'src/services/auth/constants';
import { ClientConfigProvider } from './ClientConfigProvider';

export namespace ClickstreamConfigurationService {
    export class ConfigProvider extends ClientConfigProvider {
        public get clickstreamSDK(): string {
            if (this.runtimeConfig.isLowerEnvironment) {
                return 'https://js.zg-api.test.zillow.net/a/z/js/v1/analytics.js';
            }
            return 'https://js.zg-api.com/a/z/js/v1/analytics.js';
        }

        public get sdkConfiguration(): {
            zillow: {
                anonymousId: string | undefined;
                apiKey: string;
                writeKey: string;
                apiHost: string;
                secure: boolean;
            };
        } {
            if (this.runtimeConfig.isLowerEnvironment) {
                return {
                    zillow: {
                        anonymousId: Cookies.get(COOKIES_LOOKUP.SESSION_GUID),
                        apiKey: 'z_test',
                        writeKey: 'z_dev_web',
                        apiHost: 'analytics-zg-api.test.zillow.net',
                        secure: true,
                    },
                };
            }
            return {
                zillow: {
                    anonymousId: Cookies.get(COOKIES_LOOKUP.SESSION_GUID),
                    apiKey: 'z_prod',
                    writeKey: 'z_prod_web',
                    apiHost: 'e.zg-api.com',
                    secure: true,
                },
            };
        }
    }
}
